import ErrorHandler from 'common/error/components/error-handler';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { setFeatureConfig } from 'react-awesome-feature-toggles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { compose } from 'redux';
import {
  getIsDecimal,
  setActiveServiceCenter,
} from '../../../header/service-center-toggle/containers/service-center-toggle-actions';
import { setFullScreen } from '../../../planning-board/containers/planning-board-actions';
import { fetchPowerBiReports } from '../../../power-bi/containers/power-bi-actions';
import { checkEnv } from '../../../utils/helpers';
import Spinner from '../../spinner/components/spinner';
import { fetchUser as fetch } from '../../user/containers/user-actions';

const UserContainer = ({
  fetchUser,
  children,
  isLoggedIn,
  error,
  features,
  intl,
  username,
  id,
  fullScreen,
  setIsFullScreen,
  getDecimal,
  setCurrentServiceCenter,
  defaultServiceCenter,
  activeServiceCenter,
}) => {
  const dispatch = useDispatch();
  const [shouldOpenUserSnap, setShouldOpenUserSnap] = useState(false);
  useEffect(() => {
    fetchUser();
  }, []);

  // prevent unknown service center if the user create a new session
  useEffect(() => {
    if (id) {
      if (activeServiceCenter) {
        getDecimal(activeServiceCenter);
      }
      // check for powerBi reports
      dispatch(fetchPowerBiReports());
    }
  }, [activeServiceCenter, id]);

  useEffect(() => {
    if (defaultServiceCenter) {
      if (!activeServiceCenter) {
        setCurrentServiceCenter(defaultServiceCenter);
      }
    }
  }, [defaultServiceCenter]);

  const listener = (event) => {
    // Ctrl + q to open usersnap
    if (event.ctrlKey && event.which === 81) {
      event.preventDefault();
      if (window?.usersnapApi) {
        if (fullScreen) {
          setIsFullScreen(false);
          setShouldOpenUserSnap(true);
        } else {
          window.usersnapApi.open();
        }
      }
    }
  };

  useEffect(() => {
    // Need to update the fullscreen prop in the listener
    document.removeEventListener('keydown', listener);
    document.addEventListener('keydown', listener);
    if (shouldOpenUserSnap && !fullScreen) {
      if (window?.usersnapApi) {
        window.usersnapApi.open();
      }
      setShouldOpenUserSnap(false);
    }
  }, [fullScreen]);


  useEffect(() => {
    if (id) {
      window.onUsersnapLoad = (api) => {
        api.init({
          useLocalStorage: false,
          button: { isHidden: true },
        });
        api.on('open', (event) => {
          const environment = checkEnv();
          const serviceCenter = JSON.parse(localStorage.getItem('serviceCenter')).value;
          event.api.setValue('visitor', username || id || '');
          event.api.setValue('custom', { environment, serviceCenter });
        });
        window.usersnapApi = api;
      };
      const script = document.createElement('script');
      script.async = 1;
      // eslint-disable-next-line max-len
      script.src = 'https://widget.usersnap.com/load/8f2c205a-4c60-4c27-8c31-9299bdf2f0e7?onload=onUsersnapLoad';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [id]);

  if (features && Object.keys(features) && Object.keys(features).length) {
    setFeatureConfig(features);
  }
  if (Object.keys(error).length) {
    return <Router><ErrorHandler type='alert' error={error} /></Router>;
  }
  if (isLoggedIn) {
    return children;
  }

  return intl.messages['messages.REDIRECTING_LOGIN'] ?
    <Spinner title={<FormattedMessage id='messages.REDIRECTING_LOGIN' />} /> :
    <Spinner />;
};

const mapStateToProps = state => ({
  isLoggedIn: state.user.isLoggedIn,
  error: state.user.error,
  features: state.user.features,
  username: state.user.username,
  fullScreen: state.planningBoard.fullScreen,
  isDecimal: state.serviceCenter.isDecimal,
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
  defaultServiceCenter: state.user.defaultServiceCenter,
  id: state.user.id,
});

UserContainer.propTypes = {
  children: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  error: PropTypes.object,
  features: PropTypes.object.isRequired,
  intl: PropTypes.object,
  username: PropTypes.string,
  fullScreen: PropTypes.bool,
  setIsFullScreen: PropTypes.func,
  getDecimal: PropTypes.func,
  setCurrentServiceCenter: PropTypes.func,
  defaultServiceCenter: PropTypes.string,
  activeServiceCenter: PropTypes.string,
  id: PropTypes.string,
};

const mapDispatchToProps = {
  fetchUser: fetch,
  setIsFullScreen: setFullScreen,
  getDecimal: getIsDecimal,
  setCurrentServiceCenter: setActiveServiceCenter,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(UserContainer);
